import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=fa2d1ca0&scoped=true&"
import script from "./Layers.vue?vue&type=script&lang=js&"
export * from "./Layers.vue?vue&type=script&lang=js&"
import style0 from "./Layers.vue?vue&type=style&index=0&id=fa2d1ca0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2d1ca0",
  null
  
)

export default component.exports